import axios from "axios";

// Same-origin API base: the ingress routes /api on whichever domain serves the page,
// which avoids the platform ingress stripping cross-origin CORS headers entirely.
export const API =
  (typeof window !== "undefined" ? window.location.origin : process.env.REACT_APP_BACKEND_URL) + "/api";

export const api = axios.create({ baseURL: API });

const TOKEN_KEY = "ank_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function apiError(err, fallback = "Something went wrong. Please try again.") {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  }
  if (typeof detail?.msg === "string") return detail.msg;
  return fallback;
}
